/**
 * Gets the output token address from a route array. 
 * @param {Array} route - The route array from getRoute response
 *   Each step object must contain a tokenOut property.
 * 
 * @returns {string|undefined} The output token address or undefined if route is invalid
 *   - Returns out token contract address for valid routes
 * 
 * @example
 * // Example 1: Get output token for SEI -> USDC route
 * const route = await getRoute({
 *   tokenIn: "0x0", // SEI
 *   tokenOut: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", // USDC
 *   amountIn: '1'
 * });

 * const tokenOut = getTokenOut(route);
* console.log(tokenOut); // "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
 * @note This function returns WSEI address for native SEI output too. getRouteDetails function handles SEI inputs but this function does not. Careful when using externally.
 */
export const getTokenOut = (route) => {
  if (!route || !Array.isArray(route)) {
    console.error("Invalid or missing `route`: Must be an array.");
    return undefined;
  }
  return route[0].at(-1).tokenOut.toLowerCase();
};
